import React, { useState, useCallback } from 'react';

import CoverSection from '@components/Section/Cover';
import AyatSection from '@components/Section/Ayat';
import WeddingSection from '@components/Section/Wedding';
import PhotoGallery from '@components/Section/PhotoGallery';
import FooterSection from '@components/Section/Footer';
import CoupleInfo from '@components/Section/CoupleInfo';

import Layout from '@components/Layout';
import FloatingMusic from '@components/Common/FloatingMusic/Lazy';
import WithAnimation from '@components/Common/WithAnimation';
import DarkmodeNotification from '@components/Common/DarkmodeNotification';
import Navigation from '@/components/Common/Navigation';

import useLang from '@/hooks/useLang';

import * as FEATURE from '@/constants/feature-flags';
import * as ID from '@/constants/identifier';

const ELEMENT_CONTENT_ID = 'invitato-detail-content';

export default function Home() {
  const [showDetailContent, setShowDetailContent] = useState(false);
  const lang = useLang();

  /**
   * function to show detail invitation
   * @returns {void}
   */
  const handleClickDetail = useCallback(() => {
    setShowDetailContent(true);
  }, []);

  /**
   * function to render invitation content
   * @returns {JSX.Element}
   */
  const renderContent = () => {
    if (!showDetailContent) return null;

    return (
      <div id={ELEMENT_CONTENT_ID}>
        <AyatSection />
        <CoupleInfo />
        {false && <WeddingSection name={ID.ID_DETAIL_SECTION} lang={lang} />}
        <PhotoGallery name={ID.ID_GALLERY} lang={lang} />
        <FooterSection lang={lang} />
      </div>
    );
  };

  return (
    <Layout>
      <FloatingMusic shouldShowMusicIcon={showDetailContent} />
      {FEATURE.ENABLE_DARKMODE_NOTIFICATION && <DarkmodeNotification lang={lang} />}
      {showDetailContent && <Navigation />}
      <WithAnimation top collapse when={!showDetailContent}>
        <CoverSection elementTarget={ELEMENT_CONTENT_ID} onSeeDetail={handleClickDetail} />
      </WithAnimation>
      {renderContent()}
    </Layout>
  );
}
